var scope_0 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/c05d3c3ad3a7559b17a2080151761472.js').default;export default
        Object.assign({}, scope_0 )
    